import { Action } from '@ngrx/store';
import { PaginationState, SearchPageResultState } from '../../../../core/features/store/base-feature-state';
import { SoldToSearchResult } from '../../../../core/model';
import { loaderReducer } from '../../../../core/state/utils/loader';
import { SoldToActions } from '../actions';
import { reducer as availableEntriesReducer } from './sold-to-available-entries.reducer';

export const initialState: PaginationState<SearchPageResultState> = {
  lastUpdateTime: undefined,
  pages: {},
  pagination: undefined,
  sorts: [],
};

export function reducer(state = initialState, action: Action): any {
  switch (action.type) {
    case SoldToActions.AvailableSoldToActionTypes.LoadAvailableSoldTos:
    case SoldToActions.AvailableSoldToActionTypes.LoadAvailableSoldTosOnUserDetails:
    case SoldToActions.AvailableSoldToActionTypes.LoadAvailableSoldTosFail:
    case SoldToActions.AvailableSoldToActionTypes.LoadAvailableSoldTosOnUserDetailsFail: {
      const availableSoldTosAction = <SoldToActions.AvailableSoldTosActions>action;
      const searchParams = availableSoldTosAction.searchParams;
      const loaderState = loaderReducer<SearchPageResultState>(availableSoldTosAction.searchType, availableEntriesReducer)(
        undefined,
        availableSoldTosAction
      );
      return {
        ...state,
        pages: {
          ...state.pages,
          [searchParams.page]: loaderState,
        },
      };
    }
    case SoldToActions.AvailableSoldToActionTypes.LoadAvailableSoldTosSuccess:
    case SoldToActions.AvailableSoldToActionTypes.LoadAvailableSoldTosOnUserDetailsSuccess: {
      const successAction = <SoldToActions.LoadAvailableSoldTosSuccess>action;
      const payload: SoldToSearchResult = successAction.payload;
      const searchParams = successAction.searchParams;
      const loaderState = loaderReducer<SearchPageResultState>(successAction.searchType, availableEntriesReducer)(
        { ...state.pages[searchParams.page] },
        successAction
      );
      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        pagination: payload.pagination,
        sorts: payload.sorts,
        pages: {
          ...state.pages,
          [searchParams.page]: loaderState,
        },
      };
    }
    default:
      return state;
  }
}
